var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.152 1.3568C9.54367 0.730128 10.4563 0.730129 10.848 1.3568L18.0166 12.8266C18.5592 13.6948 17.6014 14.7207 16.698 14.2389L10.4707 10.9176C10.1765 10.7608 9.8236 10.7608 9.52949 10.9176L3.30194 14.239C2.39857 14.7208 1.44074 13.6948 1.98336 12.8266L9.152 1.3568Z",
    fill: "#F7FDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletUp);
export default __webpack_public_path__ + "static/media/bullet-up.95e828ad46d76d527fcb93e29e4b0e11.svg";
export { ForwardRef as ReactComponent };